import React from 'react';
import FormikWrapper from "../../../../components/form/FormikWrapper";
import * as Yup from "yup";
import { Schema } from "yup";
import { Grid } from "@mui/material";
import SubmitButton from "../../../../components/form/SubmitButton";

const SingleFieldForm: React.FC<SingleFieldFormProps> = props => {
    let schema: Schema | undefined = undefined;

    if (props.schema) {
        schema = Yup.object().shape({
            [props.fieldName]: props.schema
        });
    }

    return (
        <FormikWrapper
            initialValues={ { [props.fieldName]: props.initialValue === undefined ? '' : props.initialValue } }
            onSubmit={ props.onSubmit }
            validationSchema={ schema }
            buttons={ null }
        >
            {
                (formik, status) => (
                    <Grid container spacing={ 2 } justifyContent='space-between' alignItems='flex-start'>
                        <Grid item xs={ 9 } container justifyContent='flex-end'>
                            { props.children }
                        </Grid>
                        <Grid item xs={ 3 } container justifyContent='flex-end'>
                            <SubmitButton isLoading={ status.pending() }/>
                        </Grid>
                    </Grid>
                )
            }
        </FormikWrapper>
    );
}
export default SingleFieldForm;

export interface SingleFieldFormProps {
    readonly fieldName: string;
    readonly initialValue?: any;
    readonly schema?: Schema;
    readonly children: any;
    readonly onSubmit: (values) => any;
}